import { cloneDeep } from 'lodash'
import { LocaleCodes } from '../../constants/localization.constants'
import { mapLocale } from '../../utils/pageCreation.utils'
/**
 *
 * @param {*} blogFeaturedResourceData
 * @param {*} tagFilters an array of blogTag names (name field)
 * @returns
 */
export const getBlogFeaturedResource = (blogFeaturedResourceData: any, tagFilters: any = []) => {
  let blogFeaturedResource
  if (
    blogFeaturedResourceData &&
    blogFeaturedResourceData.length &&
    blogFeaturedResourceData.length > 1
  ) {
    for (let n = 0; n < blogFeaturedResourceData.length; n++) {
      const blogFeaturedResourceItem = blogFeaturedResourceData[n]
      let containsTag: boolean = false
      if (tagFilters.length) {
        for (let i = 0; i < blogFeaturedResourceItem.tag?.length; i++) {
          const tag: any = blogFeaturedResourceItem.tag[i]
          if (tagFilters.includes(tag.title)) {
            containsTag = true
            break
          }
        }
      }

      if (!containsTag) continue
      if (blogFeaturedResource) {
        break
      }

      const unpublishDate = blogFeaturedResourceItem.unpublishDate
        ? blogFeaturedResourceItem.unpublishDate
        : undefined
      const today = new Date()
      if (unpublishDate) {
        const expiration = new Date(unpublishDate)
        if (expiration > today) {
          blogFeaturedResource = blogFeaturedResourceItem
          break
        }
      }
    }
  } else {
    blogFeaturedResource = blogFeaturedResourceData
  }

  return blogFeaturedResource
}

export const setListingBuckets = ({
  blogPosts,
  isPreview = false,
  isSecondaryBlog = false,
}: {
  blogPosts: any[]
  isPreview?: boolean
  isSecondaryBlog?: boolean
}) => {
  let categoryToBlog: any = {}
  let collectionToBlog: any = {}
  let authorListing = new Map()
  let categoryListing = new Map()
  let collectionListing = new Map()
  const listingBuckets = {
    [LocaleCodes.ENGLISH.name]: [],
    [LocaleCodes.GERMAN.name]: [],
    [LocaleCodes.FRENCH.name]: [],
    [LocaleCodes.SPANISH.name]: [],
    [LocaleCodes.JAPANESE.name]: [],
    [LocaleCodes.KOREAN.name]: [],
    [LocaleCodes.PORTUGUESE.name]: [],
    [LocaleCodes.CHINESE.name]: [],
  }
  if (blogPosts && blogPosts.length) {
    const blogPostsLength = blogPosts.length
    /*
  INITIAL LOOP THROUGH ALL ARTICLES, CONFIGURING OBJECTS
  USED FOR DIFFERENT BLOG PAGES
  */
    for (let p = 0; p < blogPostsLength; p++) {
      let blogPostData = blogPosts[p].node
      let pageLocale
      let isLocalized = false

      const localeInfo = mapLocale(blogPostData.entryLocale)
      if (localeInfo) {
        if (localeInfo.pageLocale) pageLocale = localeInfo.pageLocale
      }
      if (blogPostData.node_locale === pageLocale) {
        const useCase = blogPostData?.blogCategory?.useCase || ''
        // AUTHOR LISTING LOGIC
        if (blogPostData.author && blogPostData.author.name) {
          let authorId = `${blogPostData.author.firstName} ${blogPostData.author.lastName}`

          authorId = isPreview
            ? authorId
                .toLowerCase()
                .replace(/ *\([^)]*\) */g, '')
                .replace(/\s/g, '-')
            : authorId

          if (isSecondaryBlog && useCase) {
            if (authorListing.has(useCase)) {
              let authorListingMap = authorListing.get(useCase)
              if (authorListingMap.has(authorId)) {
                authorListingMap.get(authorId)[blogPostData.entryLocale].push(blogPostData)
              } else {
                authorListingMap.set(authorId, cloneDeep(listingBuckets))
                authorListingMap.get(authorId)[blogPostData.entryLocale].push(blogPostData)
              }
            } else {
              let authorListingMap = new Map()
              authorListingMap.set(authorId, cloneDeep(listingBuckets))
              authorListingMap.get(authorId)[blogPostData.entryLocale].push(blogPostData)
              authorListing.set(useCase, authorListingMap)
            }
          } else {
            if (!authorListing.has(authorId)) {
              authorListing.set(authorId, cloneDeep(listingBuckets))
            }
            authorListing.get(authorId)[blogPostData.entryLocale].push(blogPostData)
          }
        }

        // CATEGORY LISTING LOGIC
        if (blogPostData.blogCategory && blogPostData.blogCategory.title) {
          let categoryId = blogPostData.blogCategory.overwriteUrlText
            ? blogPostData.blogCategory.overwriteUrlText
            : blogPostData.blogCategory.title

          if (isPreview) {
            if (categoryId === 'Artificial Intelligence (AI)') {
              categoryId = 'ai'
            } else if (categoryId === 'Robotic Process Automation (RPA)') {
              categoryId = 'rpa'
            }
            categoryId = categoryId
              .toLowerCase()
              .replace(/ *\([^)]*\) */g, '')
              .replace(/\s/g, '-')
          }

          if (isSecondaryBlog && useCase) {
            if (categoryListing.has(useCase)) {
              let categoryListingMap = categoryListing.get(useCase)
              if (categoryListingMap.has(categoryId)) {
                categoryListingMap.get(categoryId)[blogPostData.entryLocale].push(blogPostData)
              } else {
                categoryListingMap.set(categoryId, cloneDeep(listingBuckets))
                categoryListingMap.get(categoryId)[blogPostData.entryLocale].push(blogPostData)
              }
            } else {
              let categoryListingMap = new Map()
              categoryListingMap.set(categoryId, cloneDeep(listingBuckets))
              categoryListingMap.get(categoryId)[blogPostData.entryLocale].push(blogPostData)
              categoryListing.set(useCase, categoryListingMap)
            }
          } else {
            if (!categoryListing.has(categoryId)) {
              categoryListing.set(categoryId, cloneDeep(listingBuckets))
            }
            categoryListing.get(categoryId)[blogPostData.entryLocale].push(blogPostData)
          }
        }

        // COLLECTION/TAG LISTING LOGIC
        if (blogPostData.blogTags) {
          for (let tag of blogPostData.blogTags) {
            if (tag.title) {
              let tagId = tag.overwriteUrlText ? tag.overwriteUrlText : tag.title
              if (isPreview) {
                if (tagId === 'Digital Transformation') {
                  tagId = 'digital-business-transformation'
                } else if (tagId === 'Automation') {
                  tagId = 'enterprise-automation'
                } else if (tagId === 'Finance & Accounting (F&A)') {
                  tagId = 'finance-and-accounting'
                }
                tagId = tagId
                  .toLowerCase()
                  .replace(/ *\([^)]*\) */g, '')
                  .replace(/\s/g, '-')
              }
              if (isSecondaryBlog && useCase) {
                if (collectionListing.has(useCase)) {
                  let collectionListingMap = collectionListing.get(useCase)
                  if (collectionListingMap.has(tagId)) {
                    collectionListingMap.get(tagId)[blogPostData.entryLocale].push(blogPostData)
                  } else {
                    collectionListingMap.set(tagId, cloneDeep(listingBuckets))
                    collectionListingMap.get(tagId)[blogPostData.entryLocale].push(blogPostData)
                  }
                } else {
                  let collectionListingMap = new Map()
                  collectionListingMap.set(tagId, cloneDeep(listingBuckets))
                  collectionListingMap.get(tagId)[blogPostData.entryLocale].push(blogPostData)
                  collectionListing.set(useCase, collectionListingMap)
                }
              } else {
                if (!collectionListing.has(tagId)) {
                  collectionListing.set(tagId, cloneDeep(listingBuckets))
                }
                collectionListing.get(tagId)[blogPostData.entryLocale].push(blogPostData)
              }
            }
          }
        }

        // ----------------  Related BLOG POSTS LOGIC BEGIN ----------------
        // TAG LISTING LOGIC
        if (blogPostData.blogTags && blogPostData.blogTags.length) {
          for (let tag of blogPostData.blogTags) {
            if (tag.title) {
              let tagId = tag.overwriteUrlText ? tag.overwriteUrlText : tag.title

              if (isSecondaryBlog && useCase) {
                if (useCase in collectionToBlog) {
                  let tagListingMap = collectionToBlog[useCase]
                  if (tagId in tagListingMap) {
                    tagListingMap[tagId][blogPostData.entryLocale].push(blogPostData)
                  } else {
                    tagListingMap[tagId] = cloneDeep(listingBuckets)
                    tagListingMap[tagId][blogPostData.entryLocale].push(blogPostData)
                  }
                } else {
                  let tagListingMap: any = {}
                  tagListingMap[tagId] = cloneDeep(listingBuckets)
                  tagListingMap[tagId][blogPostData.entryLocale].push(blogPostData)
                  collectionToBlog[useCase] = tagListingMap
                }
              } else {
                if (tagId in collectionToBlog) {
                  collectionToBlog[tagId][blogPostData.entryLocale].push(blogPostData)
                } else {
                  collectionToBlog[tagId] = cloneDeep(listingBuckets)
                  collectionToBlog[tagId][blogPostData.entryLocale].push(blogPostData)
                }
              }
            }
          }
        }

        // CATEGORY LISTING LOGIC
        if (blogPostData.blogCategory && blogPostData.blogCategory.title) {
          let category = blogPostData.blogCategory.overwriteUrlText
            ? blogPostData.blogCategory.overwriteUrlText
            : blogPostData.blogCategory.title
          let categoryArray: any[] = [] // categoryToBlog[category]
          if (isSecondaryBlog && blogPostData.entryLocale && useCase) {
            if (categoryToBlog[useCase]) {
              const categoryUseCaseArray = categoryToBlog[useCase]
              if (categoryUseCaseArray[category]) {
                categoryArray = categoryUseCaseArray[category][blogPostData.entryLocale]
              } else {
                categoryUseCaseArray[category] = cloneDeep(listingBuckets)
                categoryArray = categoryUseCaseArray[category][blogPostData.entryLocale]
              }
            } else {
              categoryToBlog[useCase] = {}
              categoryToBlog[useCase][category] = cloneDeep(listingBuckets)
              categoryArray = categoryToBlog[useCase][category][blogPostData.entryLocale]
            }
          } else {
            if (categoryToBlog[category]) {
              categoryArray = categoryToBlog[category]
            }
            if (!categoryToBlog[category]) {
              categoryToBlog[category] = cloneDeep(listingBuckets)
            }
            categoryArray = categoryToBlog[category][blogPostData.entryLocale]
          }
          if (categoryArray && categoryArray.length < 4) {
            categoryArray.push(blogPostData)
          }
        }

        // ----------------  Related BLOG POSTS LOGIC ENDS ----------------
      }
    }
  }

  return {
    collectionToBlog,
    categoryToBlog,
    authorListing,
    categoryListing,
    collectionListing,
  }
}

export const setBlogHomePageFeaturedSets = (allBlogPosts: any, max = 4) => {
  let primaryPost
  let secondaryPosts = []
  let excludeBlogFeatured = []

  if (!allBlogPosts) return {}

  for (let p = 0; p < allBlogPosts.length; p++) {
    if (primaryPost && secondaryPosts.length === max) {
      break
    }
    if (
      allBlogPosts[p] &&
      allBlogPosts[p].node &&
      allBlogPosts[p].node.blogFeature &&
      Array.isArray(allBlogPosts[p].node.blogFeature)
    ) {
      const blogFeatureArr = allBlogPosts[p].node.blogFeature
      if (!primaryPost && blogFeatureArr.indexOf('Primary') !== -1) {
        primaryPost = allBlogPosts[p]
        excludeBlogFeatured.push(p)
      } else if (secondaryPosts.length !== max && blogFeatureArr.indexOf('Secondary') !== -1) {
        secondaryPosts.push(allBlogPosts[p])
        excludeBlogFeatured.push(p)
      }
    }
  }

  return { primaryPost, secondaryPosts, excludeBlogFeatured }
}
